import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { getAlertsData, getConsolidatedData, getDeviceStatusData } from "../../services/dashboardService";
import { LeftArrowWhite } from '../../assets/images';
import AlertTemplateMessage from "../Configuration/AlertTemplate/AlertTemplateMessage";
import { DASHBOARD_INTERVAL_TIMER } from "../../config";

const initialCardData = {
  SiteId: null,
  SiteName: "",
  Alerts: {},
  Devices: {},
};

const getcsvFileName = (param1, param2) => {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  const csvFileName = `${param1.toLowerCase()}_${param2.toLowerCase()}_data_${yyyy}-${mm}-${dd}`;
  return csvFileName;
};

const formatDate = (date) => {
  const pad = (n) => n.toString().padStart(2, "0");
  return (
    date.getFullYear() +
    "-" +
    pad(date.getMonth() + 1) +
    "-" +
    pad(date.getDate()) +
    " " +
    pad(date.getHours()) +
    ":" +
    pad(date.getMinutes()) +
    ":" +
    pad(date.getSeconds())
  );
};

const OrgDashboard = ({
  setSelectedTab,
  handleModalShow,
}) => {
  const [cardDataList, setCardDataList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const location = useLocation();
  const clientName = location.state?.clientName || "Unknown";
  const ClientId = location.state?.ClientId || "";
  const history = useHistory();

  const user = JSON.parse(localStorage.getItem("user"));
  const UserID = user?.Id;

  const fetchDashboardAPIData = (globalFilter = {}) => {
    const alert30DaysPayload = [{
      "WidgetID": 102,
      "WidgetType": "GroupBy",
      "Datapoints": ["SiteID", "SiteName"]
    }];

    const now = new Date();
    const toDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      23,
      59,
      59,
      999
    );
    const fromDate = new Date(toDate);
    fromDate.setDate(toDate.getDate() - 29); // 30 days range
    fromDate.setHours(0, 0, 0, 0);

    // Call Consolidated API first
    getConsolidatedData({
      UserID: UserID,
      widgets: [
        {
          WidgetID: 102,
          WidgetType: "GroupBy",
          Datapoints: ["SiteID", "SiteName"],
        },
      ],
      filters: globalFilter,
    })
    .then((consolidatedRes) => {
      if (consolidatedRes && consolidatedRes.Status === "success") {
        const consolidatedWidgetData = consolidatedRes.Data[0]?.WidgetData || [];
        
        // Filter out records with null SiteID or SiteName, and create base card data
        const baseCardDataList = consolidatedWidgetData
          .filter((item) => item.SiteID !== null && item.SiteName !== null)
          .map((item) => {
            // Extract the first city name from City object
            const cityName = item.City ? Object.keys(item.City)[0] : "Not Available";
            // Extract the first branch ID from BranchId object
            const branchId = item.BranchId ? Object.keys(item.BranchId)[0] : "Not Available";
            
            return {
              ...initialCardData,
              SiteId: item.SiteID || item.SiteId || item.Siteid,
              SiteName: item.SiteName || "",
              City: cityName,
              BranchId: branchId,
              Entity: item.Entity || {},
            };
          });

        // Now fetch device data and merge
        getDeviceStatusData({
          UserID,
          widgets: [{
            WidgetID: 102,
            WidgetType: "GroupBy",
            Datapoints: ["SiteID", "SiteName"],
          }],
          filters: globalFilter,
        }).then((deviceRes) => {
          let mergedWithDevices = baseCardDataList;
          
          if (deviceRes && deviceRes.Status === "success") {
            const deviceWidgetData = deviceRes.Data[0]?.WidgetData || [];
            
            // Merge device data into base cards
            mergedWithDevices = baseCardDataList.map((card) => {
              const deviceItem = deviceWidgetData.find(
                (item) => (item.SiteID || item.SiteId) === card.SiteId
              );
              return {
                ...card,
                Devices: deviceItem?.Data || {},
              };
            });
          }

          // Finally fetch alerts and merge
          getAlertsData({
            UserID,
            widgets: alert30DaysPayload,
            DateRange: 30,
            FromDateTime: formatDate(fromDate),
            ToDateTime: formatDate(toDate),
            filters: globalFilter,
          }).then((alertRes) => {
            let finalCardDataList = mergedWithDevices;
            
            if (alertRes && alertRes.Status === "success") {
              const alertWidgetData = alertRes.Data[0]?.WidgetData || [];
              
              // Merge alert data into cards
              finalCardDataList = mergedWithDevices.map((card) => {
                const alertItem = alertWidgetData.find(
                  (item) => (item.SiteID || item.SiteId) === card.SiteId
                );
                return {
                  ...card,
                  Alerts: alertItem || {},
                };
              });
            }
            
            setCardDataList(finalCardDataList);
          }).catch((alertErr) => {
            console.error("Error fetching alerts:", alertErr);
            setCardDataList(mergedWithDevices);
          });
          
        }).catch((deviceErr) => {
          console.error("Error fetching device data:", deviceErr);
          
          // Still try to fetch alerts even if device data fails
          getAlertsData({
            UserID,
            widgets: alert30DaysPayload,
            DateRange: 30,
            FromDateTime: formatDate(fromDate),
            ToDateTime: formatDate(toDate),
            filters: globalFilter,
          }).then((alertRes) => {
            let finalCardDataList = baseCardDataList;
            
            if (alertRes && alertRes.Status === "success") {
              const alertWidgetData = alertRes.Data[0]?.WidgetData || [];
              
              finalCardDataList = baseCardDataList.map((card) => {
                const alertItem = alertWidgetData.find(
                  (item) => (item.SiteID || item.SiteId) === card.SiteId
                );
                return {
                  ...card,
                  Alerts: alertItem || {},
                };
              });
            }
            
            setCardDataList(finalCardDataList);
          }).catch((alertErr) => {
            console.error("Error fetching alerts:", alertErr);
            setCardDataList(baseCardDataList);
          });
        });
        
      } else {
        console.error("Error in consolidated data response");
        setCardDataList([]);
      }
    })
    .catch((consolidatedErr) => {
      console.error("Error fetching consolidated data:", consolidatedErr);
      setCardDataList([]);
    });

  }

  useEffect(() => {
    setSelectedTab && setSelectedTab("dashboard");

    fetchDashboardAPIData({ CustomerID: [ClientId] });    
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      fetchDashboardAPIData({ CustomerID: [ClientId] });
    }, DASHBOARD_INTERVAL_TIMER);

    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, [DASHBOARD_INTERVAL_TIMER])

  // Filter cardDataList by site name
  const filteredCardDataList = cardDataList.filter((card) =>
    card.SiteName?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Flatten Devices for UI: [{ deviceType, statuses: [{ status, count }], Interfacetypename }]
  const flattenDevices = (devices) => {
    const deviceMap = new Map();
    
    Object.entries(devices || {}).forEach(([Interfacetypename, deviceTypes]) => {
      Object.entries(deviceTypes).forEach(([deviceType, statusObj]) => {
        const key = `${Interfacetypename}-${deviceType}`;
        
        if (!deviceMap.has(key)) {
          deviceMap.set(key, {
            deviceType,
            Interfacetypename,
            statuses: []
          });
        }
        
        // Add all statuses for this device type
        Object.entries(statusObj).forEach(([status, count]) => {
          deviceMap.get(key).statuses.push({ status, count });
        });
      });
    });
    
    const result = Array.from(deviceMap.values());
    return result;
  };

  const gotoDashboard = (SiteName, siteId) => {
    history.push({
      pathname: "/site-details",
      state: { SiteName, clientName, siteId, ClientId },
    });
  };

  const handlebackCustomer = () => {
    history.push({
      pathname: "/segmented",
    });
  };

  return (
    <>
      <div className="CustomerMainDiv">
        <div className="NameHeading1 ml-3" style={{ display: "flex" }}>
          <button className="addCustomer" onClick={handlebackCustomer}>
            <span className="ViewUpdate">
              <img src={LeftArrowWhite} alt="back icon" />
            </span>
          </button>
          <p className="config-tool-head">Customer: {clientName}</p>
        </div>
        <div className="d-flex align-items-center justify-content-end">
          <div className="HeaderSiteList siteSearchDiv">
            <input
              type="text"
              placeholder="Search site here"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ padding: "8px", width: "100%", height: "40px" }}
            />
          </div>
        </div>
      </div>
      <div className="col-lg-12 mt-3 float-left OrgMaiDiv">
        <div className="dashboard-container">
          {filteredCardDataList.length > 0 ? (
            filteredCardDataList.map((card, index) => {
              const siteId = card.SiteId || card.SiteID;
              return (
                <div key={index} className="card">
                  <div
                    className="card-header"
                    onClick={() => gotoDashboard(card.SiteName, siteId)}
                    style={{ cursor: "pointer" }}
                  >
                    Site:<span>{card.SiteName}</span>
                  </div>
                  <div className="card-content">
                    <div className="device-list">
                      <div className="info-box">City <br /> <span>{card.City}</span></div>
                      <div className="info-box">Branch ID<br /> <span>{card.BranchId}</span></div>
                      
                      <div className="info-box device-card alertBox">
                        <div className="device-title">Alerts</div>
                        <div className="alertStatusCount">
                          {card.Alerts && card.Alerts.AlertStatus
                            ? Object.entries(card.Alerts.AlertStatus).map(([status, count]) => (
                                <span
                                  key={status}
                                  style={{ cursor: handleModalShow ? 'pointer' : 'default', marginRight: 8 }}
                                  onClick={() => handleModalShow && handleModalShow({ AlertStatus: status },'Alert',30,{ SiteID: [siteId] },getcsvFileName('Alert', status),'Alerts')}
                                >
                                  {count} {status}
                                </span>
                              ))
                            : (
                              <span>No Alerts Available</span>
                            )
                          }
                        </div>
                      </div>
                      {/* Devices */}
                      {flattenDevices(card.Devices).length > 0 ? (
                        flattenDevices(card.Devices).map((dev, devIdx) => (
                          <div className="device-card" key={devIdx}>
                            <div className="device-title">{dev.deviceType}</div>
                            <div className="device-status">
                              {dev.statuses.map((statusItem, statusIdx) => (
                                <span
                                  key={statusIdx}
                                  className={
                                    (statusItem.status === "Online" || statusItem.status === "Normal" ? "online" : statusItem.status === "Offline" || statusItem.status === "Faulty" ? "offline" : "")
                                  }
                                  style={{
                                    cursor: handleModalShow ? "pointer" : "default",
                                    color: statusItem.status === "Online" || statusItem.status === "Normal" ? "#28a745" : statusItem.status === "Offline" || statusItem.status === "Faulty" ? "#dc3545" : "#555",
                                    marginRight: statusIdx < dev.statuses.length - 1 ? "8px" : "0"
                                  }}
                                  onClick={() =>
                                    handleModalShow &&
                                    handleModalShow(
                                      { 'StatusFor':dev.deviceType,
                                        'DeviceStatus': statusItem.status,
                                        'InterfaceTypeName': dev.Interfacetypename,
                                        'IntegrationStatus': dev.Interfacetypename === 'CCTV' ? 'Integrated' : null
                                      },
                                      "DeviceStatus",
                                      null,
                                      { SiteID: [siteId] },
                                      getcsvFileName(dev.deviceType, statusItem.status),
                                      dev.deviceType,
                                    )
                                  }
                                >
                                  {statusItem.count} {statusItem.status}
                                </span>
                              ))}
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="info-box device-card alertBox" >
                          <div className="device-title">Devices</div>
                            <span>No Devices Available</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            // <p>No sites found</p>
            <AlertTemplateMessage message="No sites found" />
          )}
        </div>
      </div>
    </>
  );
};

export default OrgDashboard;